"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.openModal = exports.saveStagedChanges = exports.SaveStagedChanges = exports.SaveStagedChangesRequestTypes = exports.AccountDefaultActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _Route = require("../constants/Route");

var AccountDefaultActionTypes = (0, _namespacedKeyMirror.default)({
  SAVE_STAGED_CHANGES: null,
  OPEN_MODAL: null,
  CLOSE_MODAL: null
}, _Route.ROUTE);
exports.AccountDefaultActionTypes = AccountDefaultActionTypes;
var SaveStagedChangesRequestTypes = (0, _actions.createRequestTypes)(AccountDefaultActionTypes.SAVE_STAGED_CHANGES);
exports.SaveStagedChangesRequestTypes = SaveStagedChangesRequestTypes;
var SaveStagedChanges = (0, _actions.createRequestActions)(SaveStagedChangesRequestTypes, {
  successMetaCreator: function successMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SaveStagedChangesRequestTypes.base, _RequestStatusTypes.default.SUCCEEDED), (0, _actions.createSuccessNotificationMeta)(_I18n.default.text('accountdefaults.notifications.success')));
  },
  failureMetaCreator: function failureMetaCreator() {
    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(SaveStagedChangesRequestTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(_I18n.default.text('accountdefaults.notifications.error')));
  }
});
exports.SaveStagedChanges = SaveStagedChanges;
var saveStagedChanges = (0, _fluxActions.createAction)(AccountDefaultActionTypes.SAVE_STAGED_CHANGES);
exports.saveStagedChanges = saveStagedChanges;
var openModal = (0, _fluxActions.createAction)(AccountDefaultActionTypes.OPEN_MODAL, function (modalName) {
  return modalName;
});
exports.openModal = openModal;
var closeModal = (0, _fluxActions.createAction)(AccountDefaultActionTypes.CLOSE_MODAL);
exports.closeModal = closeModal;